export default __webpack_public_path__ + "static/media/Layer 22.c3a00dc0.svg";